import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function RecipientTableRowSkeleton({ index }) {
    return (
        <tr key={index}>
            <td><Skeleton variant="text" width="80%" height={24} /></td>
            <td><Skeleton variant="text" width="60%" height={24} /></td>
            <td><Skeleton variant="text" width="60%" height={24} /></td>
            <td><Skeleton variant="text" width="80%" height={24} /></td>
            <td><Skeleton variant="rectangular" width={24} height={24} className="oct_skeleton-radius-4" /></td>
        </tr>
    );
}

export default RecipientTableRowSkeleton;
